import BackgroundOne from './bg-1.png';
import BackgroundTwo from './bg-2.png';
import BackgroundThree from './bg-3.png';
import BackgroundFour from './bg-4.png';

// import noImage from './no-image.jpg';
import noImage from './no-image.jpg';
import noImageArticle from './no-image-article.jpg';

import JournalBackground from './cafe-frankfurt-germany.png'
import Bookshelf from './Group 1686551451.png'
import BGProfile from './bg-profile.png'

export const BackgroundPath = {
    BackgroundOne,
    BackgroundTwo,
    BackgroundThree,
    BackgroundFour,
    JournalBackground,
    Bookshelf,
    BGProfile
}

export const ImageContent = {
    noImage,
    noImageArticle
}